import { httpClient } from 'angieslist-app-platform';

const addressesService = {
  getSPAddresses(spid) {
    return httpClient.get(
      `/gateway/service-provider-profile/v1/service_provider/${spid}/address`,
      {
        headers: {
          'X-ANGI-CallerType': 'ServiceProvider',
          'X-ANGI-CallerId': spid,
        },
      },
    );
  },
};

export default addressesService;



// WEBPACK FOOTER //
// ./src/modules/store/common/addressesService.js